/*
 * File: /src/services/formFieldProfileService.js
 * Created Date: Thursday November 4th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Sunday, 28th November 2021 11:32:18 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

import { authedAxios } from '../shared/axiosWrapper';
import { AD_BASE_FORM_FIELD_PROFILE_PATH } from '../constants';

export default {
  /**
   * Fetch All Profiles
   *
   * @returns
   */
  fetchAll(params) {
    return authedAxios.get(AD_BASE_FORM_FIELD_PROFILE_PATH, { params: params });
  },

  fetchById(id) {
    return authedAxios.get(AD_BASE_FORM_FIELD_PROFILE_PATH + id, {});
  },

  updateFormFieldProfile(id, payload) {
    return authedAxios.put(AD_BASE_FORM_FIELD_PROFILE_PATH + id, payload);
  },

  createFormFieldProfile(payload) {
    return authedAxios.post(AD_BASE_FORM_FIELD_PROFILE_PATH, payload);
  },

  deleteFormFieldProfile(id) {
    return authedAxios.delete(AD_BASE_FORM_FIELD_PROFILE_PATH + id);
  },
};
